'use strict';

$(function () {
    var createApp = Vue.createApp;
    var ref = Vue.ref;
    var computed = Vue.computed;
    var onMounted = Vue.onMounted;
    var onUnmounted = Vue.onUnmounted;

    createApp({
        setup: function setup() {
            var isOpen = ref(false);
            var session = ref(null);
            var hasSavedQuotes = ref(false);
            var menuStyle = ref({
                top: '',
                left: ''
            });

            var getMemberApi = function getMemberApi() {
                return window.NextMovingMember || null;
            };

            var fetchUserDetails = function fetchUserDetails() {
                if (!session.value || !session.value.token) {
                    return;
                }

                var applyData = function applyData(data) {
                    if (data && data.name) {
                        session.value = Object.assign({}, session.value, {
                            customer: {
                                name: data.name,
                                email: data.email || ''
                            },
                            phone: data.phone,
                            formattedPhone: data.phone
                        });
                        var sessionStr = JSON.stringify(session.value);
                        if (typeof window.setCriticalData === 'function') {
                            window.setCriticalData('nextMovingMemberSession', sessionStr);
                        } else {
                            try {
                                localStorage.setItem('nextMovingMemberSession', sessionStr);
                            } catch (e) {}
                        }
                    }
                };
                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/auth/user',
                    type: 'GET',
                    headers: {
                        'Authorization': 'Bearer ' + session.value.token
                    },
                    success: function success(data) {
                        applyData(data);
                    },
                    error: function error(xhr) {
                        console.error('Failed to fetch user details:', xhr);
                        if (xhr.status === 401) {
                            handleSignOut();
                        }
                    }
                });
            };

            var checkSavedQuotes = function checkSavedQuotes() {
                if (!session.value || !session.value.token) {
                    hasSavedQuotes.value = false;
                    return;
                }
                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/saved-quotes',
                    type: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': 'Bearer ' + session.value.token
                    },
                    success: function success(res) {
                        var rawData = Array.isArray(res) ? res : res && Array.isArray(res.data) ? res.data : [];
                        var validQuotes = rawData.filter(function (item) {
                            var lead = item.lead || item;
                            var createdAt = item.createdAt || lead && lead.createdAt || item.created_at || lead && lead.created_at;
                            if (!createdAt) return true;
                            var orderDate = new Date(createdAt);
                            if (isNaN(orderDate.getTime())) return true;
                            var difference = Date.now() - orderDate.getTime();
                            return difference < 24 * 60 * 60 * 1000;
                        });
                        hasSavedQuotes.value = validQuotes.length > 0;
                    },
                    error: function error() {
                        hasSavedQuotes.value = false;
                    }
                });
            };

            var updateSession = function updateSession() {
                var member = getMemberApi();
                if (member && typeof member.getSession === 'function') {
                    session.value = member.getSession();
                } else {
                    try {
                        var raw = typeof window.getCriticalData === 'function' ? window.getCriticalData('nextMovingMemberSession') : localStorage.getItem('nextMovingMemberSession');
                        session.value = JSON.parse(raw || 'null');
                    } catch (error) {
                        session.value = null;
                    }
                }

                if (session.value && session.value.token) {
                    fetchUserDetails();
                    checkSavedQuotes();
                } else {
                    hasSavedQuotes.value = false;
                }
            };

            var isLoggedIn = computed(function () {
                return !!(session.value && session.value.phone);
            });

            var customerName = computed(function () {
                return session.value && session.value.customer && session.value.customer.name ? session.value.customer.name : 'My account';
            });

            var customerPhone = computed(function () {
                if (!session.value || !session.value.phone) return '';
                var member = getMemberApi();
                if (member && typeof member.formatPhone === 'function') {
                    return member.formatPhone(session.value.phone);
                }
                return session.value.formattedPhone || session.value.phone;
            });

            var toggleMenu = function toggleMenu() {
                if (!isLoggedIn.value) {
                    window.location.href = '/member-login';
                    return;
                }
                setMenuOpen(!isOpen.value);
            };

            var setMenuOpen = function setMenuOpen(value) {
                isOpen.value = value;
                if (value) {
                    Vue.nextTick(positionAccountMenu);
                }
            };

            var positionAccountMenu = function positionAccountMenu() {
                var button = document.querySelector('.member-account-btn');
                var menu = document.getElementById('member-account-menu');
                if (!button || !menu) return;

                var rect = button.getBoundingClientRect();
                var menuWidth = menu.offsetWidth || 300;
                var menuHeight = menu.offsetHeight || 180;
                var gap = 10;
                var top = rect.bottom + gap;
                var left = rect.right - menuWidth;
                var maxLeft = window.innerWidth - menuWidth - 10;

                if (left < 10) {
                    left = 10;
                } else if (left > maxLeft) {
                    left = maxLeft;
                }

                if (top + menuHeight > window.innerHeight - 10) {
                    top = Math.max(10, rect.top - menuHeight - gap);
                }

                menuStyle.value = {
                    top: Math.round(top) + 'px',
                    left: Math.round(left) + 'px'
                };
            };

            var handleSignOut = function handleSignOut() {
                var member = getMemberApi();
                if (member && typeof member.logout === 'function') {
                    member.logout();
                } else {
                    if (typeof window.removeCriticalData === 'function') {
                        window.removeCriticalData('nextMovingMemberSession');
                    } else {
                        try {
                            localStorage.removeItem('nextMovingMemberSession');
                        } catch (e) {}
                    }
                }

                setMenuOpen(false);
                updateSession();

                var currentPath = window.location.pathname.replace(/\/$/, '');
                if (currentPath === '/member-area' || currentPath === '/member-order') {
                    window.location.href = '/member-login';
                }
            };

            var handleOutsideClick = function handleOutsideClick(event) {
                var button = document.querySelector('.member-account-btn');
                var menu = document.getElementById('member-account-menu');
                if (menu && button && !menu.contains(event.target) && !button.contains(event.target)) {
                    setMenuOpen(false);
                }
            };

            var handleKeyDown = function handleKeyDown(event) {
                if (event.key === 'Escape') {
                    setMenuOpen(false);
                }
            };

            onMounted(function () {
                updateSession();
                document.addEventListener('click', handleOutsideClick);
                document.addEventListener('keydown', handleKeyDown);
                window.addEventListener('resize', positionAccountMenu);
                window.addEventListener('scroll', positionAccountMenu, { passive: true });

                window.addEventListener('nextmoving:auth-changed', updateSession);
            });

            onUnmounted(function () {
                document.removeEventListener('click', handleOutsideClick);
                document.removeEventListener('keydown', handleKeyDown);
                window.removeEventListener('resize', positionAccountMenu);
                window.removeEventListener('scroll', positionAccountMenu);
                window.removeEventListener('nextmoving:auth-changed', updateSession);
            });

            return {
                isOpen: isOpen,
                session: session,
                isLoggedIn: isLoggedIn,
                hasSavedQuotes: hasSavedQuotes,
                customerName: customerName,
                customerPhone: customerPhone,
                menuStyle: menuStyle,
                toggleMenu: toggleMenu,
                handleSignOut: handleSignOut
            };
        }
    }).mount('#member-account-app');
});